<div class="reset-password-container" *ngIf="displayed">
  <form class="reset-password-form">
    <div class="reset-password-title">Reset Password</div>
    <div class="reset-password-intro">
      <p style="color: #ff389f">Please check all your email folders for the verification code.</p>
      <p>
        Your new password must be at least 8 characters long and includes the following:
        <li class="password-req-item">Numbers</li>
        <li class="password-req-item">Upper Case Letters</li>
        <li class="password-req-item">Lower Case Letters</li>
        <li class="password-req-item">Special Characters</li>
      </p>
    </div>
    <div class="form-group">
      <!--      <label for="name">Username/email</label>-->
      <div class="input-group input-group-lg">
        <input
          class="form-control form-control-lg"
          id="name"
          type="text"
          data-lpignore="true"
          [formControl]="username"
          required
          name="name"
          placeholder="Email Address"
        />
      </div>
      <div [hidden]="username.valid || username.pristine" class="alert alert-danger">Email address is required</div>
    </div>

    <div class="form-group">
      <!--      <label for="password1">New Password</label>-->
      <div class="input-group input-group-lg">
        <input
          class="form-control form-control-lg"
          id="password1"
          data-lpignore="true"
          [type]="showPassword ? 'text' : 'password'"
          [formControl]="password1"
          name="password1"
          required
          placeholder="New Password"
          autocomplete="off"
        />
        <div class="input-group-append">
          <button *ngIf="!showPassword" (click)="showPassword = true" [attr.aria-label]="'Show password'">
            <fa-icon [icon]="faEyeSlash" title="Show Password"></fa-icon>
          </button>
          <button *ngIf="showPassword" (click)="showPassword = false" [attr.aria-label]="'Hide password'">
            <fa-icon [icon]="faEye" title="Hide Password"></fa-icon>
          </button>
        </div>
      </div>
      <div [hidden]="password1.valid || password1.pristine" class="alert alert-danger">
        Password does not meet requirements
      </div>
    </div>

    <div class="form-group">
      <!--      <label for="password2">Confirm Password</label>-->
      <div class="input-group input-group-lg">
        <input
          class="form-control form-control-lg"
          id="password2"
          data-lpignore="true"
          [type]="showPassword ? 'text' : 'password'"
          [formControl]="password2"
          name="password2"
          required
          placeholder="Confirm New Password"
          autocomplete="off"
        />
        <div class="input-group-append">
          <button *ngIf="!showPassword" (click)="showPassword = true" [attr.aria-label]="'Show password'">
            <fa-icon [icon]="faEyeSlash" title="Show Password"></fa-icon>
          </button>
          <button *ngIf="showPassword" (click)="showPassword = false" [attr.aria-label]="'Hide password'">
            <fa-icon [icon]="faEye" title="Hide Password"></fa-icon>
          </button>
        </div>
      </div>
      <div [hidden]="password2.valid || password2.pristine" class="alert alert-danger">
        Password does not meet requirements
      </div>
    </div>

    <div class="form-group">
      <!--      <label for="verification-code">Verification code</label>-->
      <div class="input-group input-group-lg">
        <input
          class="form-control form-control-lg"
          id="verification-code"
          type="text"
          data-lpignore="true"
          [formControl]="verificationCode"
          required
          placeholder="Verification Code"
          name="name"
        />
      </div>
      <div [hidden]="verificationCode.valid || verificationCode.pristine" class="alert alert-danger">
        Verification code is required
      </div>
    </div>

    <div [hidden]="!errorMessage" class="alert alert-danger">
      {{ errorMessage }}
    </div>
    <button [disabled]="!canSaveNewPassword()" class="save-password-button" (click)="saveNewPassword()">
      <ng-container *ngIf="submitted">
        <span class="sign-in-progress spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Changing Password
      </ng-container>
      <ng-container *ngIf="!submitted"> Change Password </ng-container>
    </button>
  </form>
</div>
